import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

const EducationalImagesTagFilter = ({
  facets,
  filters,
  setFilter,
  removeFilter,
}) => {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="tag"
      filters={filters}
      id="tag"
      label="Tags"
      removeFilter={removeFilter}
      setFilter={setFilter}
    />
  );
};

export default withSearch(({ facets, filters, setFilter, removeFilter }) => ({
  facets,
  filters,
  setFilter,
  removeFilter,
}))(EducationalImagesTagFilter);
